
import React, { useState } from "react";
import "./Forgot.css";
import banner_img from "../../../images/banner-picture.png";
import login_logo from "../../../images/loginlogo.png";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputLabel, Input, InputAdornment, IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { Button } from "@mui/material";
import chevronleft from "../../../images/chevronleft.svg";
import { useDispatch, useSelector } from "react-redux";
import { userForgotPasswordApi } from "../../../Services/Login/LoginApi/loginApi";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import owl_logo from "../../../images/HOA Owl Logo.svg";
import { Link } from "react-router-dom";

function ForgotComp() {
  const [email, setEmail] = useState(""); // State to hold email input
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.userLogin);
  const navigate = useNavigate();
  const [errors, setErrors] = useState({});

  // Handles email input changes and logs the email value
  const handleChange = (event) => {
    const newEmail = event.target.value;
    setEmail(newEmail); // Update email state
  
  };

  // Handles form submission
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   console.log("Submitting email:", email); // Logs the email value on submit

  //   const result = await dispatch(
  //     userForgotPasswordApi({
  //       email: email,
  //     })
  //   );
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Email Validation (Only shows error below input)
    const newErrors = {};
    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Invalid email format";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      return; //  Stop function execution if validation errors exist
    }

   

    //  API Call
    const result = await dispatch(userForgotPasswordApi({ email }));

    if (userForgotPasswordApi.fulfilled.match(result)) {
      toast.success("Password reset link sent successfully!");
      navigate(`/confirm-account-otp?email=${encodeURIComponent(email)}`);
    } else {
      const errorMessage = result.payload?.message || "Please enter the correct email!";
      toast.error(errorMessage); //  Show error in toast only
      console.error("Failed to submit email:", errorMessage);
    }
  }
 

  const handleBackClick = () => {
    navigate(-1); // Navigates to the previous page
  };

  return (
    <>
      <section className="login-page-one forgot-pw-section">
        <div className="container-fluid p-0">
          <div className="row-forgotpw">
            <div className="forgotpw-box forget_page">
              <div className="login-right-block">
                <div className="login-logoimg text-center forgotpw-block"></div>
                <div className="back-btn">
                <div className="back-btn">
                  <a href="javascript:void(0)" onClick={handleBackClick}>
                    <img
                      src={chevronleft}
                      alt="chevron-left"
                      class="left-icon"
                    ></img>
                    Back
                  </a>
                </div>
                </div>
              </div>
              <div className="forgt-pw-block">
                <div className="login-information d-flex justify-content-center flex-column align-items-center">
                  <div className="login-logoimg text-center">
                    <Link to="/">
                      <img
                        src={owl_logo}
                        alt="login-logo"
                        className="login_logo_img"
                      />
                    </Link>
                  </div>
                  <div>
                    <h1 className="text-center m-0">Forgot Password</h1>
                    <p className="pw-texts text-center mt-1">
                      Please enter the email address associated with your
                      account.
                    </p>
                    <div className="form-login text-left">
                      <div className="mb-4">
                        <InputLabel htmlFor="standard-adornment-email">
                          Business Email <span>*</span>
                        </InputLabel>
                        <Input
                          className="email-input-box"
                          id="standard-adornment-email"
                          type="email"
                          placeholder="Email"
                          value={email} // Bind value to state
                          onChange={handleChange} // Call handleChange to update state
                        />{/*  Error Message Just Below Input */}
      {errors.email &&<p style={{ color: "red" }} className="text-red-500 text-sm">{errors.email}</p>}
                      </div>
                      <div className="btn-orange">
                        <Button onClick={handleSubmit}>Send Reset Code</Button>
                      </div>
                      <div className="lower-signup-text text-center">
                        {/* <p>
                          Need Help? <a href="">Click Here</a>
                        </p> */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
      </section>
    </>
  );
}

export default ForgotComp;
